import './B2bCalculationApi';
import './MaskApplicator';

if (typeof window.B2bCalculationForm === 'undefined') {
    window.B2bCalculationForm = class B2bCalculationForm {
        constructor() {
            this.isSaving = false;
            this.captchaWidgetId = null;
            this.api = new window.B2bCalculationApi();
            this.eventRegister();
            new window.MaskApplicator(document.querySelector('[data-b2b-form]'));
            this.initCaptcha();
        }

        eventRegister() {
            const form = document.querySelector('[data-b2b-form]');
            form.onsubmit = this.handleSubmit.bind(this);

            const fields = document.querySelectorAll('[data-b2b-form] [data-field]');
            for (const field of fields) {
                field.oninput = this.clearFieldError.bind(this, field);
                field.onchange = this.clearFieldError.bind(this, field);
            }
        }

        initCaptcha() {
            const scriptSrc = 'https://smartcaptcha.yandexcloud.net/captcha.js';

            if (window.smartCaptcha) {
                this.renderCaptcha();
                return;
            }

            if (!document.querySelector(`script[src*="smartcaptcha.yandexcloud.net"]`)) {
                const script = document.createElement('script');
                script.src = scriptSrc;
                script.async = true;
                script.onload = this.renderCaptcha.bind(this);
                document.head.appendChild(script);
                return;
            }

            const waitForCaptcha = () => {
                if (window.smartCaptcha) {
                    this.renderCaptcha();
                    return;
                }
                window.setTimeout(waitForCaptcha, 100);
            };
            waitForCaptcha();
        }

        renderCaptcha() {
            const container = document.querySelector('[data-b2b-captcha]');
            if (this.captchaWidgetId !== null) {
                return;
            }

            this.captchaWidgetId = window.smartCaptcha.render(container.id, {
                sitekey: container.getAttribute('data-sitekey'),
            });
        }

        resetCaptcha() {
            if (!window.smartCaptcha) {
                return;
            }

            if (this.captchaWidgetId !== null) {
                window.smartCaptcha.reset(this.captchaWidgetId);
                return;
            }

            window.smartCaptcha.reset();
        }

        validate() {
            const fields = document.querySelectorAll('[data-b2b-form] [data-field]');
            for (const field of fields) {
                if (field.disabled || field.hidden || field.closest('[hidden]')) {
                    continue;
                }

                const valid = field.checkValidity();
                field.classList.toggle('is-invalid', !valid);
                if (!valid) {
                    field.reportValidity();
                    return false;
                }
            }

            const captchaInput = document.querySelector('[data-b2b-captcha] input[name="smart-token"]');
            if (!captchaInput || captchaInput.value === '') {
                this.showStatus('Пожалуйста, подтвердите, что вы не робот', true);
                return false;
            }

            return true;
        }

        clearFieldError(field) {
            field.classList.remove('is-invalid');
        }

        showStatus(message, isError) {
            const status = document.querySelector('[data-b2b-form-status]');
            status.hidden = false;
            status.textContent = message;
            status.classList.toggle('b2b-form__status--error', isError);
            status.classList.toggle('b2b-form__status--success', !isError);
        }

        hideStatus() {
            const status = document.querySelector('[data-b2b-form-status]');
            status.hidden = true;
            status.textContent = '';
        }

        async handleSubmit(event) {
            event.preventDefault();

            if (this.isSaving) {
                return;
            }

            this.hideStatus();
            if (!this.validate()) {
                return;
            }

            this.isSaving = true;
            const submit = document.querySelector('[data-b2b-form-submit]');
            submit.disabled = true;

            try {
                await this.api.send(this.api.collect());
                document.querySelector('[data-b2b-form]').reset();
                document.querySelector('[data-b2b-form] [data-mask="phone"]').imask.value = '';
                this.resetCaptcha();
                this.showStatus('Заявка отправлена', false);
            } catch (error) {
                this.showStatus(error.message, true);
                this.resetCaptcha();
            } finally {
                this.isSaving = false;
                submit.disabled = false;
            }
        }
    };
}
